query MyQueryPages($slug: [String], $formTemplateOptions: String, $lang: [String]) {
  page: entry(section: "pages", slug: $slug, site: $lang) {
    ... on pages_pages_Entry {
      id
      title
      page {
        ... on page_sectionTitle_BlockType {
          sectionTitle
          typeHandle
          id
        }
        ... on page_table2Columns_BlockType {
          table {
            col1
            col2
          }
          typeHandle
          id
        }
        ... on page_featuredPartner_BlockType {
          typeHandle
          id
          featuredPartners {
            id
            title
          }
        }
        ... on page_partner_BlockType {
          id
          typeHandle
          partners {
            id
            title
          }
        }
        ... on page_text_BlockType {
          id
          typeHandle
          textContent
        }
        ... on page_introduction_BlockType {
          id
          typeHandle
          introduction
        }
        ... on page_images_BlockType {
          id
          typeHandle
          imagesLayout
          imagesAlignment
          images {
            width
            height
            url
            alt
          }
        }
        ... on page_titreImage_BlockType {
          id
          typeHandle
          sectionTitle
          sectionImage {
            width
            height
            url
            alt
          }
          sectionLink
        }
        ... on page_contentImage_BlockType {
          id
          typeHandle
          contentText
          image {
            width
            height
            url
            alt
          }
        }
        ... on page_form_BlockType {
          id
          typeHandle
          form {
            id
            handle
            configJson
            templateHtml(options: $formTemplateOptions)
          }
        }
      }
    }
  }
}